module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/1cover#cover"
    }
  }, [_vm._v("THE FURIES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/5start#chap1"
    }
  }, [_vm._v("Introduction - Our Heroine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/7chap2#chap2"
    }
  }, [_vm._v("The Kent Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/8chap3#chap3"
    }
  }, [_vm._v("Book One: Turn Loose Your Wolf")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/9chap4#chap4"
    }
  }, [_vm._v("Chapter I The Chapel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/10chap5#chap5"
    }
  }, [_vm._v("Chapter II The Massacre")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/11chap6#chap6"
    }
  }, [_vm._v("Chapter III The Bargain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/12chap7#chap7"
    }
  }, [_vm._v("Chapter IV The Camp Follower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/13chap8#chap8"
    }
  }, [_vm._v("Chapter V The Corn of San Jacinto")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/14chap9#chap9"
    }
  }, [_vm._v("The Journal of Jephtha Kent, 1844: Bishop Andrew's Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/15chap10#chap10"
    }
  }, [_vm._v("Book Two: Gold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/16chap11#chap11"
    }
  }, [_vm._v("Chapter I Cry in the Wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/17chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II The Fever")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/18chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III Christmas Among the Argonauts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/19chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV To See the Elephant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/20chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V The Man Who Got in the Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/21chap16#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI The Parting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/22chap17#chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Journal of Jephtha Kent, 1850: A Higher Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/23chap18#chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Three: Perish with the Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/24chap19#chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I The Legacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/25chap20#chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II Of Books and Bloomers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/26chap21#chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III The Man Who Thundered")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/27chap22#chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV Suspicion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/28chap23#chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V The Girl Who Refused")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/29chap24#chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI Of Stocks and Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/30chap25#chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII The Box")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/31chap26#chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII The Slave Hunter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/32chap27#chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX Besieged")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/33chap28#chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X Destruction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/34chap29#chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XI Judgment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/teaser00",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: The Lawless")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/1cover#cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE TITANS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/6chap1#chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue THE NIGHT OF THE RAILSPLITTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/8chap2#chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book One BLACK APRIL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/9chap3#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I \"AN OATH REGISTERED IN HEAVEN\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/10chap4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II COLONEL LEE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/11chap5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III MOLLY'S HOPE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/12chap6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV FAN'S FEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/13chap7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V THE RIOT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/14chap8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI THE DETECTIVES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/15chap9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII O ABSALOM!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/16chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII THE BAIT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/17chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX BLOODY BALTIMORE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/18chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X ACCUSATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/19chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XI BEHOLD THE DARKNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/20chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interlude THE GIRL I LEFT BEHIND ME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/21chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Two RED JULY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/22chap16#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I CITY AT THE EDGE OF WAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/23chap17#chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II THE AMATEUR CAVALIER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/24chap18#chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III THE TIGERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/25chap19#chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV LOST LOVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/26chap20#chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V WITH JEB STUART")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/27chap21#chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI \"THE BALL IS OPEN\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/28chap22#chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII RIDE TO GLORY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/29chap23#chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII THE WATERS OF WRATH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/30chap24#chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX THE WOUNDED")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/31chap25#chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X THE MURDERER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/32chap26#chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XI \"AND IF A HOUSE BE DIVIDED--\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/33chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XII THE BETTER ANGELS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/34chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/36chap30#chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A KENT FAMILY TREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/1cover#cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WARRIORS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/5start#chap1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction: Enjoying the Sweep of History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/7chap2#chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Kent Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/8chap3#chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prologue at Chancellorsville The Fallen Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/10chap4#chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book One: In Destruction's Path")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/11chap5#chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I Soldier Alone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/12chap6#chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II \"Sixty Thousand Strong\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/13chap7#chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III The Slave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/14chap8#chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV Rosewood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/15chap9#chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V The Women")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/16chap10#chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI Shadow of the Enemy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/17chap11#chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII Warnings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/18chap12#chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII With Serena")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/19chap13#chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX Red Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/20chap14#chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X The Prisoner")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/21chap15#chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Two: War like a Thunderbolt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/22chap16#chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I Enemy at the Gate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/23chap17#chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II Invasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/24chap18#chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III The Bummers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/25chap19#chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV Serena's Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/26chap20#chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V Night of Ruin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/27chap21#chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI Day of Death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/28chap22#chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII \"Let 'Em Up Easy\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/29chap23#chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Three: The Fire Road")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/30chap24#chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I Escape to the West")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/31chap25#chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II The Railhead")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/32chap26#chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III The Captain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/33chap27#chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV \"A March as Glorious as Sherman's\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/34chap28#chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V Rage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/35chap29#chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI Jephtha's Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/36chap30#chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII Dorn's Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/37chap31#chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII The Bible and the Knife")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/38chap32#chap32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX At Lance Point")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/39chap33#chap33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X Hunter's Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/40chap34#chap34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Four: Hell-on-Wheels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/41chap35#chap35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I The Cheyenne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/42chap36#chap36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II Armed Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/43chap37#chap37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III The Race")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/44chap38#chap38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV Slaughter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/45chap39#chap39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V \"To Every Purpose Under Heaven\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/46chap40#chap40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI The Coming of the Godless")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/47chap41#chap41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII The Vow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/48chap42#chap42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII Meridian 100")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/49chap43#chap43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX Kingston")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/50chap44#chap44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X A Matter of Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/51chap45#chap45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XI A Matter of Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/52chap46#chap46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Five: The Scarlet Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/53chap47#chap47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I Meeting with a Mountebank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/54chap48#chap48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II The Tame Dog")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/55chap49#chap49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III The Portrait")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/56chap50#chap50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV The Man in the Burned Shawl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/57chap51#chap51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V The Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/58chap52#chap52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI The Accident")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/59chap53#chap53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII Call to War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/60chap54#chap54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII At the Universal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/61chap55#chap55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX \"I'm on Top, Ain't I?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/62chap56#chap56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X Casualty of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/63chap57#chap57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue at Kentland The Lifted Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/pteaser00",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("The Lawless")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/bio_images",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Biography of John Jakes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27d5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 66
// module chunks = 0